// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"06d23cb5","324":"e55d78f1","666":"1405ae03","800":"26bae506","802":"a083366a","956":"5580a02b","972":"6e4c997f"}[chunkId] + ".chunk.js";
};